import { useState } from "react";

const reviews = [
  {
    id: 1,
    name: "Ayşe Kılıç",
    avatar: "https://readdy.ai/api/search-image?query=Turkish%20woman%20portrait%20smiling%20professional%20headshot%20warm%20natural%20light%2030s&width=120&height=120&seq=rev-av1&orientation=squarish",
    location: "İstanbul",
    rating: 5,
    date: "Mart 2026",
    destination: "Kapadokya",
    text: "Kapadokya'ya ilk kez gittim ve bu site sayesinde hiç bilmediğim vadileri keşfettim. Balon turu için önerilen şirket mükemmeldi, sabah 5'te kalkmaya değdi! Kaya otel önerisi de tam isabet — manzara inanılmazdı.",
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20hot%20air%20balloon%20sunrise%20golden%20hour%20fairy%20chimneys%20Turkey%20travel%20photo&width=400&height=250&seq=rev-img1&orientation=landscape",
  },
  {
    id: 2,
    name: "Mehmet Arslan",
    avatar: "https://readdy.ai/api/search-image?query=Turkish%20man%20portrait%20smiling%20professional%20headshot%20warm%20natural%20light%2040s&width=120&height=120&seq=rev-av2&orientation=squarish",
    location: "Ankara",
    rating: 5,
    date: "Şubat 2026",
    destination: "Gaziantep",
    text: "Gastronomi rehberi sayesinde İmam Çağdaş'ta sabah 7'de katmer yedim — hayatımın en iyi kahvaltısı! Beyran çorbası için de erken kalktım, pişman olmadım. Gaziantep'i 3 günde gezmek yetmedi, tekrar gideceğim.",
    image: "https://readdy.ai/api/search-image?query=Gaziantep%20baklava%20pistachio%20Turkish%20sweets%20traditional%20pastry%20shop%20authentic%20food&width=400&height=250&seq=rev-img2&orientation=landscape",
  },
  {
    id: 3,
    name: "Selin Yıldız",
    avatar: "https://readdy.ai/api/search-image?query=young%20Turkish%20woman%20portrait%20smiling%20casual%20headshot%20natural%20light%2025s&width=120&height=120&seq=rev-av3&orientation=squarish",
    location: "İzmir",
    rating: 5,
    date: "Ocak 2026",
    destination: "Halfeti",
    text: "Halfeti'yi bu sitede keşfettim ve inanamadım — Türkiye'de böyle bir yer var mıymış! Tekne turunda su altındaki cami minaresini görmek gerçekten büyüleyiciydi. Siyah güller için Nisan'da tekrar gideceğim.",
    image: "https://readdy.ai/api/search-image?query=Halfeti%20Turkey%20Euphrates%20river%20boat%20tour%20submerged%20mosque%20minaret%20water%20reflection%20scenic&width=400&height=250&seq=rev-img3&orientation=landscape",
  },
  {
    id: 4,
    name: "Can Öztürk",
    avatar: "https://readdy.ai/api/search-image?query=young%20Turkish%20man%20portrait%20smiling%20casual%20headshot%20natural%20light%2028s&width=120&height=120&seq=rev-av4&orientation=squarish",
    location: "Bursa",
    rating: 5,
    date: "Aralık 2025",
    destination: "Bozcaada",
    text: "Bozcaada rehberi sayesinde Corvus Winery'yi keşfettim. Bağ bozumu döneminde gittiğimiz için şarap tadımı deneyimi inanılmazdı. Ayazma Plajı'nda çam ormanının içinde kamp yapmak da ayrı bir deneyimdi.",
    image: "https://readdy.ai/api/search-image?query=Bozcaada%20Turkey%20Aegean%20island%20vineyard%20winery%20stone%20castle%20blue%20sea%20summer&width=400&height=250&seq=rev-img4&orientation=landscape",
  },
  {
    id: 5,
    name: "Zeynep Demir",
    avatar: "https://readdy.ai/api/search-image?query=Turkish%20woman%20portrait%20smiling%20professional%20headshot%20warm%20natural%20light%2035s&width=120&height=120&seq=rev-av5&orientation=squarish",
    location: "Trabzon",
    rating: 4,
    date: "Kasım 2025",
    destination: "Ayder Yaylası",
    text: "Karadeniz yaylaları rehberi sayesinde Pokut'u keşfettim — Ayder'den çok daha sakin ve otantikti. Sabah sisi içinde ahşap evleri görmek masalsıydı. Muhlama ve karalahana çorbası için de doğru adresleri bulduk.",
    image: "https://readdy.ai/api/search-image?query=Ayder%20plateau%20Turkey%20Black%20Sea%20green%20mountains%20wooden%20houses%20mist%20waterfall%20Kackar&width=400&height=250&seq=rev-img5&orientation=landscape",
  },
  {
    id: 6,
    name: "Ahmet Çelik",
    avatar: "https://readdy.ai/api/search-image?query=Turkish%20man%20portrait%20smiling%20professional%20headshot%20warm%20natural%20light%2045s&width=120&height=120&seq=rev-av6&orientation=squarish",
    location: "Konya",
    rating: 5,
    date: "Ekim 2025",
    destination: "Göbeklitepe",
    text: "Nemrut ve Göbeklitepe rehberi sayesinde 4 günlük mükemmel bir güzergah planladım. Göbeklitepe'de rehberli tur aldım ve 12.000 yıllık tarihi gerçekten hissettim. Nemrut'ta gün doğumu için sabah 3'te kalkmak kesinlikle değdi!",
    image: "https://readdy.ai/api/search-image?query=Gobeklitepe%20ancient%20stone%20pillars%20T-shaped%20neolithic%20temple%20Turkey%20archaeological%20UNESCO&width=400&height=250&seq=rev-img6&orientation=landscape",
  },
];

const ReviewsSection = () => {
  const [activeIdx, setActiveIdx] = useState(0);
  const visibleCount = 3;

  const visibleReviews = reviews.slice(activeIdx, activeIdx + visibleCount);

  const prev = () => setActiveIdx((p) => Math.max(0, p - 1));
  const next = () => setActiveIdx((p) => Math.min(reviews.length - visibleCount, p + 1));

  const avgRating = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-4">
          <div>
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-widest">Gerçek Deneyimler</span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Gezginlerin Yorumları
            </h2>
            <p className="text-stone-400 text-sm mt-2 max-w-md">
              Rehberlerimizi kullanarak Türkiye'yi keşfeden gezginlerin gerçek deneyimleri ve hikayeleri.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>{avgRating}</div>
              <div className="flex items-center gap-0.5 justify-center mt-1">
                {[1,2,3,4,5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className={parseFloat(avgRating) >= s ? "ri-star-fill text-amber-400 text-sm" : "ri-star-line text-amber-300 text-sm"}></i>
                  </div>
                ))}
              </div>
              <p className="text-stone-400 text-xs mt-1">{reviews.length} değerlendirme</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                disabled={activeIdx === 0}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-200 text-stone-500 hover:border-amber-400 hover:text-amber-500 transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <i className="ri-arrow-left-line text-sm"></i>
              </button>
              <button
                onClick={next}
                disabled={activeIdx >= reviews.length - visibleCount}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-200 text-stone-500 hover:border-amber-400 hover:text-amber-500 transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {visibleReviews.map((review) => (
            <article key={review.id} className="bg-stone-50 rounded-2xl overflow-hidden border border-stone-100 hover:border-amber-200 transition-colors">
              {/* Destination image */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src={review.image}
                  alt={review.destination}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="flex items-center gap-1 bg-amber-500/90 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                    <i className="ri-map-pin-line"></i>
                    {review.destination}
                  </span>
                </div>
              </div>

              <div className="p-5">
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-3">
                  {[1,2,3,4,5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className={review.rating >= s ? "ri-star-fill text-amber-400 text-sm" : "ri-star-line text-amber-300 text-sm"}></i>
                    </div>
                  ))}
                </div>

                {/* Quote */}
                <div className="w-6 h-6 flex items-center justify-center mb-2">
                  <i className="ri-double-quotes-l text-amber-300 text-2xl"></i>
                </div>
                <p className="text-stone-600 text-sm leading-relaxed line-clamp-4">{review.text}</p>

                {/* Author */}
                <div className="flex items-center gap-3 mt-4 pt-4 border-t border-stone-200">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={review.avatar} alt={review.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-semibold text-stone-800 text-sm">{review.name}</p>
                    <div className="flex items-center gap-1 text-stone-400 text-xs">
                      <i className="ri-map-pin-2-line text-xs"></i>
                      <span>{review.location}</span>
                      <span>·</span>
                      <span>{review.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-8">
          {Array.from({ length: reviews.length - visibleCount + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIdx(i)}
              className={`rounded-full transition-all cursor-pointer ${activeIdx === i ? "w-6 h-2 bg-amber-500" : "w-2 h-2 bg-stone-300 hover:bg-stone-400"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
